<template lang="pug">
  div.checkout-form(v-if="cart")
    div.checkout-form__field.checkout-form__field-address(v-if="currentShipmentType && currentShipmentType.name === 'delivery'")
      IconMarker()
      input(type="text",v-model="cart.to_address",placeholder="Địa chỉ giao hàng" readonly)

    div.checkout-form__field.checkout-form__field-username
      IconUser()
      input(type="text",v-model="cart.username",placeholder="Tên người nhận" @change="updateSessionCart")

    div.checkout-form__field.checkout-form__field-phone
      IconPhone()
      input(type="text",v-model="cart.user_id",placeholder="Số điện thoại" @change="updateSessionCart")

    div.checkout-form__field.checkout-form__field-note
      IconNote()
      textarea(type="text",v-model="cart.note",placeholder="Ghi chú cho đơn hàng này" @change="updateSessionCart")

    //pre {{ cart }}

    div.checkout-form__field.checkout-form__field-time(v-if="currentShipmentType && currentShipmentType.name !== 'pickup'")
      div
        label.field-radio(for="shipment-time-1") Giao sớm nhất có thể
          input( id="shipment-time-1", type="radio", v-model="cart.delivery_time_type", value="Giao sớm nhất có thể" @change="onChange")
          span.field-radio-button
      div
        label.field-radio(for="shipment-time-2") Hẹn giờ giao hàng
          input( id="shipment-time-2", type="radio", v-model="cart.delivery_time_type" value="Hẹn giờ giao hàng" @change="onChange")
          span.field-radio-button
    div.checkout-form__field.checkout-form__field-time(v-else)
      div(v-if="false")
        label.field-radio(for="shipment-time-1") Giao sớm nhất có thể
          input( id="shipment-time-1", type="radio", v-model="cart.delivery_time_type", value="Giao sớm nhất có thể" @change="onChange")
          span.field-radio-button
      div
        label.field-radio(for="shipment-time-2") Giờ lấy hàng
          input( id="shipment-time-2", type="radio", v-model="cart.delivery_time_type" value="Giờ lấy hàng" @change="onChange")
          span.field-radio-button
    div.shipment-time
      .shipment-time__dropdown(v-if="isSelectTime")
        .shipment-time__select.shipment-time__select-date(@click.prevent="isShowDateDropdown = !isShowDateDropdown")
          svg(class='icon-svg-calender' width='24' height='24' viewbox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg')
            path(d='M21 8.5V17.75C21 19.5449 19.5449 21 17.75 21H6.25C4.45507 21 3 19.5449 3 17.75V8.5H21ZM7.25 15C6.55964 15 6 15.5596 6 16.25C6 16.9404 6.55964 17.5 7.25 17.5C7.94036 17.5 8.5 16.9404 8.5 16.25C8.5 15.5596 7.94036 15 7.25 15ZM12 15C11.3096 15 10.75 15.5596 10.75 16.25C10.75 16.9404 11.3096 17.5 12 17.5C12.6904 17.5 13.25 16.9404 13.25 16.25C13.25 15.5596 12.6904 15 12 15ZM7.25 10.5C6.55964 10.5 6 11.0596 6 11.75C6 12.4404 6.55964 13 7.25 13C7.94036 13 8.5 12.4404 8.5 11.75C8.5 11.0596 7.94036 10.5 7.25 10.5ZM12 10.5C11.3096 10.5 10.75 11.0596 10.75 11.75C10.75 12.4404 11.3096 13 12 13C12.6904 13 13.25 12.4404 13.25 11.75C13.25 11.0596 12.6904 10.5 12 10.5ZM16.75 10.5C16.0596 10.5 15.5 11.0596 15.5 11.75C15.5 12.4404 16.0596 13 16.75 13C17.4404 13 18 12.4404 18 11.75C18 11.0596 17.4404 10.5 16.75 10.5ZM17.75 3C19.5449 3 21 4.45507 21 6.25V7H3V6.25C3 4.45507 4.45507 3 6.25 3H17.75Z' fill='#ADA8A8')
          input(:value="cart.delivery_time_date" placeholder="Chọn ngày" readonly)
          svg(class='icon-svg-caret' width='18' height='10' viewbox='0 0 18 10' fill='none' xmlns='http://www.w3.org/2000/svg')
            path(d='M17.7071 0.292891C18.0676 0.653381 18.0953 1.22061 17.7903 1.6129L17.7071 1.70711L9.7071 9.7071C9.3466 10.0676 8.7794 10.0953 8.3871 9.7903L8.2929 9.7071L0.2929 1.70711C-0.0975991 1.31658 -0.0975991 0.68342 0.2929 0.29289C0.6534 -0.0675901 1.2206 -0.09532 1.6129 0.2097L1.7071 0.29289L9 7.5858L16.2929 0.292891C16.6834 -0.0976294 17.3166 -0.0976294 17.7071 0.292891Z' fill='#ADA8A8')

          select(v-model="cart.delivery_time_date" hidden)
            option(v-for="d in dates" :value="d.value") {{ d.text }}
          .shipment-time__select-date__dropdown(v-if="isShowDateDropdown")
            ul
              li(v-for="d in dates" :value="d.value" @click="cart.delivery_time_date = d.value" :class="{'is-active':d.value === cart.delivery_time_date}") {{ d.text }}

        .shipment-time__select.shipment-time__select-hour(@click.prevent="isShowHourDropdown = !isShowHourDropdown")
          svg(class='icon-svg-time' width='20' height='20' viewbox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg')
            path(d='M13.25 11.5H9.25C8.836 11.5 8.5 11.164 8.5 10.75V4.75C8.5 4.336 8.836 4 9.25 4C9.664 4 10 4.336 10 4.75V10H13.25C13.664 10 14 10.336 14 10.75C14 11.164 13.664 11.5 13.25 11.5ZM10 0C4.478 0 0 4.478 0 10C0 15.522 4.478 20 10 20C15.522 20 20 15.522 20 10C20 4.478 15.522 0 10 0Z' fill='#ADA8A8')

          vue-timepicker(v-model="cart.delivery_time_hour" :minute-interval="15" :hour-range="[[9, 21]]" hide-disabled-seconds hide-disabled-items placeholder="Chọn giờ")

          svg( v-if="!cart.delivery_time_hour" class='icon-svg-caret' width='18' height='10' viewbox='0 0 18 10' fill='none' xmlns='http://www.w3.org/2000/svg')
            path(d='M17.7071 0.292891C18.0676 0.653381 18.0953 1.22061 17.7903 1.6129L17.7071 1.70711L9.7071 9.7071C9.3466 10.0676 8.7794 10.0953 8.3871 9.7903L8.2929 9.7071L0.2929 1.70711C-0.0975991 1.31658 -0.0975991 0.68342 0.2929 0.29289C0.6534 -0.0675901 1.2206 -0.09532 1.6129 0.2097L1.7071 0.29289L9 7.5858L16.2929 0.292891C16.6834 -0.0976294 17.3166 -0.0976294 17.7071 0.292891Z' fill='#ADA8A8')



</template>
<script>
  import IconMarker from "./icons/IconMarker";
  import IconUser from "./icons/IconUser";
  import IconPhone from "./icons/IconPhone";
  import IconNote from "./IconNote";
  import VueTimepicker from 'vue2-timepicker'
  import 'vue2-timepicker/dist/VueTimepicker.css'

  import { mapGetters } from 'vuex'
  import { bus } from '../main'

  Date.prototype.addHours= function(h){
    this.setHours(this.getHours()+h);
    return this;
  }

  export default {
    name: 'CheckoutForm',
    components: {IconNote, IconPhone, IconUser, IconMarker, VueTimepicker},
    created() {
      //console.log(this.cart.delivery_time_hour);
      if (!this.cart.delivery_time_type) this.$set(this.cart,'delivery_time_type', "Giao sớm nhất có thể")
      if ('Hẹn giờ giao hàng' === this.cart.delivery_time_type) {
        this.isSelectTime = true
      } else {
        this.isSelectTime = false
      }
      if (this.cart.order_type && 'PICK' === this.cart.order_type) {
        this.$set(this.cart,'delivery_time_type','Giờ lấy hàng')
        this.isSelectTime = true
      }
      this.getDate()

    },
    props: {
      cart: Object
    },
    computed: {
      ...mapGetters('shipments', [
        'currentShipmentType',
      ]),
      dates: function () {
        return [
          {value: this.today, text: 'Hôm nay ' + this.today} ,
          {value: this.tomorrow, text: 'Ngày mai ' + this.tomorrow} ,
        ]
      }
    },
    data () {
      return {
        isSelectTime: false,
        today: null,
        tomorrow: null,
        date: null,
        isShowDateDropdown : false,
        hour: null,
        isShowHourDropdown : false,
        hours: [
          '10:00 Sáng',
          '11:00 Trưa',
          '12:00 Trưa',
          '01:00 Chiều',
          '02:00 Chiều',
          '03:00 Chiều',
          '04:00 Chiều',
          '05:00 Chiều',
          '06:00 Tối',
          '07:00 Tối',
          '08:00 Tối',
          '09:00 Tối',
        ],

      }
    },
    methods: {

      onChange() {

        if ('Hẹn giờ giao hàng' === this.cart.delivery_time_type) {
          this.isSelectTime = true

          if(!this.cart.delivery_time_date) this.$set(this.cart,'delivery_time_date', this.dates[0].value)

          let now = new Date().getHours()
          if (!this.cart.delivery_time_hour) {
            if (now <= 9 ) {
              this.$set(this.cart,'delivery_time_hour', '10:00 Sáng')
            } else if( now <= 10) {
              this.$set(this.cart,'delivery_time_hour', '11:00 Trưa')
            } else if( now <= 12) {
              this.$set(this.cart,'delivery_time_hour', '01:00 Chiều')
            } else if( now <= 17) {
              this.$set(this.cart,'delivery_time_hour', '06:00 Tối')
            }

          }
          this.$set(this.cart,'order_type','DELIAT')
        } else if ('Giờ lấy hàng' === this.cart.delivery_time_type) {
          this.isSelectTime = true

          if(!this.cart.delivery_time_date) this.$set(this.cart,'delivery_time_date', this.dates[0].value)

          let now = new Date().getHours()
          if (!this.cart.delivery_time_hour) {
            if (now <= 9 ) {
              this.$set(this.cart,'delivery_time_hour', '10:00 Sáng')
            } else if( now <= 10) {
              this.$set(this.cart,'delivery_time_hour', '11:00 Trưa')
            } else if( now <= 12) {
              this.$set(this.cart,'delivery_time_hour', '01:00 Chiều')
            } else if( now <= 17) {
              this.$set(this.cart,'delivery_time_hour', '06:00 Tối')
            }

          }
          this.$set(this.cart,'order_type','PICK')
        } else {
          this.isSelectTime = false
          this.$set(this.cart,'delivery_time_date',null)
          this.$set(this.cart,'delivery_time_hour',null)
          this.$set(this.cart,'order_type','DELI')
        }
        this.updateSessionCart()
      },
      getDate() {
        let today = new Date(), tomorrow = new Date(today)
        tomorrow.setDate(today.getDate() + 1)
        this.today = today.toLocaleDateString('vi-VN')
        this.tomorrow = tomorrow.toLocaleDateString('vi-VN')
      },
      updateSessionCart(data) {
        bus.$emit('updateSessionCart', data)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/CheckoutForm.vue